module.exports = __webpack_public_path__ + "img/coupon-popup-bg.3ac074d1.png";